/**
 * Client-side mirror of `ComplaintAttachmentService`'s
 * ALLOWED_TYPES/MAX_BYTES/MAX_PER_COMPLAINT (backend). Shared by
 * `ComplaintNewPage` (pre-create staging via `LocalAttachmentStager`) and
 * `ComplaintAttachmentList` (post-create upload) so the two surfaces can't
 * drift out of sync with each other or with the backend limits.
 */
export const COMPLAINT_ALLOWED_TYPES = [
  "image/jpeg", "image/png", "image/gif", "image/webp",
  "application/pdf",
  "application/zip",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain", "text/csv",
];
export const COMPLAINT_MAX_BYTES = 25 * 1024 * 1024;
export const COMPLAINT_MAX_FILES = 10;
